import React from 'react';
import PropTypes from 'prop-types';

import BaseWizard from 'containers/BaseWizard';
import NumberedSidebar from 'containers/BaseWizard/components/Sidebars/NumberedSidebar';
import WidgetSettings  from './WidgetSettings';
import Confirmation from './Confirmation';
import themeable from 'zignal-landscape/lib/themeable';

const BulkEditionWizard = ({
  profileOptions,
  smartFilters,
  handleClose,
  setSetting,
  setSelectedCols,
  onFooterFinish,
  sideBarSummary,
  BulkEdition,
  backButton,
  timezone
}) => {

  return (
    <BaseWizard
      enableFooter
      cancelModalProps={{
        title: 'Your changes will not be saved',
        text: `By clicking “Exit Bulk Edit”, 
        your changes will not be saved 
        and you will exit Bulk Edit Mode. Do you want to exit?`,
        confirmStyle:'alert',
        confirmText: 'Exit Bulk Edit',
        boldText: 'Are you sure you want to exit Bulk Edit Mode?'
      }}
      enableCancelModal
      wizardStore={BulkEdition}
      sidebarComponent={<NumberedSidebar title={'Bulk Edit'} summary={sideBarSummary} />}
      onFooterBack={backButton}
      onClose={handleClose}
    >
      <WidgetSettings
        title={'Update Settings'}
        pageHeader={'Update Settings'}
        smartFilters={smartFilters}
        profileOptions={profileOptions}
        setSetting={setSetting}
        onFooterBack={null}
        setSelectedCols={setSelectedCols}
        timezone={timezone}
      />
      <Confirmation
        title={'Confirm'}
        pageHeader={'Confirm Changes'}
        onFooterBack={backButton}
        smartFilters={smartFilters}
        profileOptions={profileOptions}
        onFooterNext={onFooterFinish}
      />
    </BaseWizard>
  );
};

BulkEditionWizard.propTypes = {
  handleClose: PropTypes.func,
  profileOptions: PropTypes.array,
  smartFilters: PropTypes.array,
  setSetting: PropTypes.func,
  setSelectedCols: PropTypes.func,
  onFooterFinish: PropTypes.func,
  backButton: PropTypes.func,
  sideBarSummary: PropTypes.array,
  BulkEdition: PropTypes.object,
  timezone: PropTypes.string
};

export default themeable(BulkEditionWizard);
